export const STATUS_LIST = ['Activo', 'Inactivo'];
export const PERFILS = ['Bronze', 'Silver', 'Gold'];
